import actions from '../action/idCard'
import CONSTANT from '../constant/idCard'
import {
  Toast,
} from 'mint-ui'
export default {
  actions,
  state: {
    idCardFrontFile: '',
    idCardBackFile: '',
    name: '',
    identity: '',
    errorForName: false,
  },
  getters: {

  },
  mutations: {
    setIdCardFront(state, file) {
      return state.idCardFrontFile = file
    },
    setIdCardBack(state, file) {
      return state.idCardBackFile = file
    },
    removeIdCardBack(state) {
      return state.idCardBackFile = ''
    },
    removeIdCardFront(state) {
      return state.idCardFrontFile = ''
    },
    errorForChangeName(state) {
      state.errorForName = true
    },
    initIdCardState(state) {
      return state = {
        idCardFrontFile: '',
        idCardBackFile: '',
        name: '',
        identity: '',
        errorForName: false,
      }
    },
    setIdentityAndName(state, data) {
      state.name = data.name
      state.identity = data.identity
    },
    [CONSTANT.IDCARD_SAVEIDENTITY_SUCCESS](state, data) {

    },
    [CONSTANT.IDCARD_SAVEIDENTITY_ERROR](state, e) {
    },
    [CONSTANT.IDCARD_GETIDENTITYINFO_SUCCESS](state, data) {
      state.name = state.name ? state.name : data.realName
      state.identity = state.identity ? state.identity : data.identity
    },
    [CONSTANT.IDCARD_GETIDENTITYINFO_ERROR](state, e) {
    },
    [CONSTANT.IDCARD_CHECKIDENTITY_SUCCESS] (state, data) {
    },
    [CONSTANT.IDCARD_CHECKIDENTITY_ERROR] (state, e) {

    },
        /*yeoman-template-point-1*/
  }
}
